module.exports = __webpack_public_path__ + "media/images/sp/articles/about-f6bd07d2ec8ab662b067530a92c345b4.webp";